import type { FieldMetaProps, FormikContextType } from 'formik'

export function isInvalid(meta: FieldMetaProps<any>): boolean {
  return Boolean(meta.error) && meta.touched
}

export function isDisabled(
  context: FormikContextType<any>,
  isNewItem?: boolean // initial values will be treated as dirty, allowing user to click save with unmodified initial values
): boolean {
  return context.isSubmitting || (!context.dirty && !isNewItem) || !context.isValid
}

export function isSubmitting(context: FormikContextType<any>): boolean {
  return context.isSubmitting
}
